import { FavouriteQuestionsState } from './_types';

export const initialState: FavouriteQuestionsState = {
    favouriteQuestions: null,
};
